import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { IvftSupplementationRedLabelAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-ivtf-supplementation-red-label-slot',
    templateUrl: './ivft-supplementation-red-label-slot.component.html',
    styleUrl: './ivft-supplementation-red-label-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IvftSupplementationRedLabelSlotComponent implements SheetSlotComponentBase {

	action!: IvftSupplementationRedLabelAction;
	value!: string | null;

	@Input('action') set updateAction(action: IvftSupplementationRedLabelAction | null) {
		this.action = action as IvftSupplementationRedLabelAction;
		this.value = this.action.rate?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}